import $http from '@/api';
import axios from 'axios';
import store from '@/store';
import { toArray } from '@/utils';
import { cloneDeep } from 'lodash';
import savedSearches from './saved-searches';

// API needs sort as array.
// UI to server format {name: "ASC"} => {"field": "publishedDate", "criteria": "DESC"}
export function formatSortParams(filters) {
  return toArray(filters)
    .map(sort => ({
      field: Object.keys(sort)
        .pop(),
      criteria: Object.values(sort)
        .pop(),
    }));
}

/**
 * @typedef SearchResponse
 * @property {Object[]} results
 * @property {Number} page
 * @property {Number} numResults
 * @property {Number} numPages
 * @property {Boolean} [canceled]
 */

/**
 * Searches for entity with given filters of the image that matches the given aspect ratios.
 * @param entity NX entity type
 * @param filters Search filters
 * @param source Axios cancel token source
 * @return {Promise<SearchResponse>}
 */
const search = async (entity, filters, source = axios.CancelToken.source()) => {
  const apiPath = store.getters.getSearcherApiPath(entity) || `/api/${entity}/search`;
  const searchFilters = cloneDeep(filters);
  if (searchFilters.sort) {
    searchFilters.sort = formatSortParams(filters.sort);
  }
  return $http
    .post(apiPath, searchFilters, { cancelToken: source.token })
    .catch((thrown) => {
      console.warn('Search exception', thrown);
      return {
        canceled: true,
        results: [],
        page: filters.page || 1,
        numResults: 0,
        numPages: 0,
      };
    });
};

const fetch = async (entity, id, source = {}, requestConfig = {}) => {
  const options = {
    ...requestConfig,
  };
  if (source.token) options.cancelToken = source.token;
  return $http
    .get(`/api/${entity}/${id}`, options)
    .catch((e) => {
      console.warn(`Error while fetching ${entity} with id ${id}`, e);
      return null;
    });
};

export default {
  search,
  fetch,
  savedSearches,
};
